import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import { useI18N } from '@tm/client-form/src/hooks/useI18n'
import { useOtherOptions } from '@tm/client-form/src/hooks/useOtherOptions'
import { DropdownField, MultidropdownField } from '@tm/shared-lib/src/field'
import { arrayValue, InputProps, stringValue } from './types'

export function DropdownInput(props: InputProps<DropdownField | MultidropdownField>) {
  const { tt } = useI18N()
  const { field, value, onChange, isSubmitting, lang } = props
  const isMultiple = field.type === 'multidropdown'
  const { otherOptionValues, otherOptionLabels, setOptionValue, otherOptionByOptionId } = useOtherOptions(
    field.name,
    field.options
  )
  const otherOptions = isMultiple
    ? arrayValue(value).filter(value => otherOptionByOptionId[value])
    : [stringValue(value)].filter(value => otherOptionByOptionId[value])

  const label = tt(field.label)

  return (
    <>
      <TextField
        value={isMultiple ? arrayValue(value) : stringValue(value, '')}
        onChange={event => {
          onChange(event.target.value)
        }}
        disabled={isSubmitting}
        fullWidth
        variant="filled"
        key={`f-${field.name}`}
        hiddenLabel={!label}
        label={label}
        SelectProps={{
          multiple: field.type === 'multidropdown',
        }}
        select>
        {field.options?.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {tt(option.label)}
          </MenuItem>
        ))}
      </TextField>
      {otherOptions.map(optionId => (
        <TextField
          value={otherOptionValues[optionId]}
          onChange={event => {
            setOptionValue(event.target.value, optionId)
          }}
          label={tt(otherOptionLabels[optionId])}
          disabled={isSubmitting}
          fullWidth
          variant="filled"
          key={`f-${field.name}-${optionId}`}
        />
      ))}
    </>
  )
}
